import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { GoogleButton } from "../components/GoogleAuth";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@clinica.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Bem-vindo!");
      navigate("/app");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Form */}
      <div className="flex-1 flex items-center justify-center p-6 bg-white">
        <div className="w-full max-w-md">
          <div className="mb-8"><Logo size={44} tagline /></div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900 mb-1">
            Entrar na conta
          </h1>
          <p className="text-sm text-slate-600 mb-8">
            Gerencie a precificação da sua clínica ou consultório.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="mt-1"
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Senha</Label>
                <Link to="/forgot-password" className="text-xs text-indigo-600 hover:underline" data-testid="link-forgot-password">
                  Esqueceu a senha?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="mt-1"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 hover:bg-indigo-700"
              data-testid="login-submit"
            >
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><span className="flex-1 h-px bg-slate-200" />ou<span className="flex-1 h-px bg-slate-200" /></div>
          <GoogleButton label="Entrar com Google" />

          <p className="mt-6 text-sm text-slate-600">
            Não tem conta?{" "}
            <Link to="/register" className="text-indigo-600 font-medium hover:underline" data-testid="link-register">
              Cadastre-se
            </Link>
          </p>
        </div>
      </div>

      {/* Image */}
      <div
        className="hidden lg:block flex-1 relative"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/9062527/pexels-photo-9062527.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-slate-900/50" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <h2 className="font-heading text-4xl font-extrabold tracking-tight">
            Preços que fazem sua clínica lucrar.
          </h2>
          <p className="mt-2 text-slate-100 max-w-md">
            Calcule hora clínica, custos e defina preços ideais, mínimos e aproximados para cada procedimento.
          </p>
        </div>
      </div>
    </div>
  );
}
